export const getters = {
  REQUEST_RUNNING: state => state.requestsRunning,
}
